module.exports = __webpack_public_path__ + "static/img/lime_th.ca2aae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/lime_th.png
// module id = 4e1Q
// module chunks = 0